import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';

type InitState = {
  isUserAdult: boolean;
  isUserSetAdult: boolean;
  pendingAuthDialog: boolean;
};

export const initialInitState: InitState = {
  isUserAdult: localStorage.getItem('isUserAdult') === 'accept',
  isUserSetAdult: localStorage.getItem('isUserAdult') !== null,
  pendingAuthDialog: false,
};

export const InitStore = signalStore(
  { providedIn: 'root' },
  withState(initialInitState),
  withMethods((state) => ({
    setIsUserAdult(isUserAdult: boolean) {
      localStorage.setItem('isUserAdult', isUserAdult ? 'accept' : 'decline');
      patchState(state, { isUserAdult, isUserSetAdult: true });
    },
    setPendingAuthDialog(pending: boolean) {
      patchState(state, { pendingAuthDialog: pending });
    },
  })),
);
